// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__UT-JF","inner":"Footer_inner__2AV9w","nextIcon":"Footer_nextIcon__1nbJe","innerLeft":"Footer_innerLeft__2wYi6"};